// extracted by mini-css-extract-plugin
export default {"PolicyScroll":"Policies-module__PolicyScroll--RdW6p","PolicyScrollFirefox":"Policies-module__PolicyScrollFirefox--Hfq93"};